module.exports = __webpack_public_path__ + "static/media/Patrik.7243c53e.jpg";